import React from 'react'
import Overview from '../OverviewTemplate'
import useSearch from '@src/hooks/useSearch'
import useTemplateDebug from '@src/hooks/useTemplateDebug'

export default ({ location, pageContext: { category } }) => {
  useTemplateDebug('CategoryPage')
  const props = useSearch({ categoryId: category.categoryId })
  return <Overview path={location.pathname} category={category} {...props} />
}
